import { useState } from 'react'
import classNames from 'classnames'
import ADVICE_QUERY from 'graphql/advice.query'

import ApplyLayout from 'components/ApplyLayout'

import s from './applyPage.module.css'
import graphqlQuery from '../helpers/graphqlQuery'
import isModellinkSite from '../helpers/isModellinkSite'
import getGlobalSettings from '../helpers/getGlobalSettings'
import getSites from '../helpers/getSites'
import StateInitializer from '../components/StateInitializer'
import { createApolloClient } from '../lib/createApolloClient'

//TODO: Setup proptypes
function ApplyPage({ globalSettings, sites, siteSlug, title, contentBlocks }) {
  const [activeSections, setActiveSections] = useState([])

  if (!contentBlocks) return null

  const toggleSection = sectionIndex => {
    const newActiveSections = [...activeSections]
    if (newActiveSections.includes(sectionIndex))
      newActiveSections.splice(newActiveSections.indexOf(sectionIndex), 1)
    else newActiveSections.push(sectionIndex)
    setActiveSections(newActiveSections)
  }

  // console.log('contentBlocks', contentBlocks[0].sections[0])
  // TODO: Possibly change field type and make this component use a 'shared blocks'
  // type of component. The fields used for the data to this area has been changed,
  // We've ported across the old components and modified them to work with the new fields
  // however this is not a perfect match
  return (
    <StateInitializer globalSettings={globalSettings} sites={sites} siteSlug={siteSlug}>
      <ApplyLayout activeArea='advice'>
        <div className={s.container}>
          <h1 className={s.title} dangerouslySetInnerHTML={{ __html: title }} />
          {contentBlocks.map(c =>
            c.sections.map(section =>
              section.subSections.map((subSection, i) => (
                <div
                  className={classNames(s.section, {
                    [s.sectionActive]: activeSections.includes(i),
                  })}
                  key={subSection.menuLabel}
                >
                  <button
                    type='button'
                    className={s.sectionTitle}
                    onClick={() => toggleSection(i)}
                  >
                    {subSection.menuLabel}
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='14'
                      height='7'
                      viewBox='0 0 14 7'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path fill='#FFF' d='M0 0h14v7H0z' />
                        <path stroke='#979797' d='M1 0l5.965 7L13 0' />
                      </g>
                    </svg>
                  </button>
                  <div
                    className={s.sectionContent}
                    dangerouslySetInnerHTML={{ __html: subSection.content }}
                  />
                </div>
              )),
            ),
          )}
        </div>
      </ApplyLayout>
    </StateInitializer>
  )
}

export default ApplyPage

export async function getStaticProps({ params }) {
  const uri = isModellinkSite() ? 'apply-modellink/advice-modellink' : 'apply/apply-advice'

  const apolloClient = createApolloClient();

  const [globalSettings, sites, data] = await Promise.all([
    getGlobalSettings(),
    getSites(),
    graphqlQuery(ADVICE_QUERY, 'WP_ROOT', { uri }),
  ])

  return {
    props: {
      ...params,
      title: data.pageBy.title,
      ...data.pageBy.acfBlocks,
      globalSettings,
      sites,
    },
    revalidate: 60 * 60 * 24, // Revalidate every 24 hours
  }
}

export async function getStaticPaths() {
  return {
    paths: [
      {
        params: {
          slug: 'advice',
        },
      },
    ],
    fallback: false,
  }
}
